import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConstant } from '../config/app.constant';
import { AppStateProvider } from '../providers/app-state.provider';
import { AdminService } from '../services/admin.service';
import { CommonService } from '../services/common.service';
export class OverviewData {
  companiesEnrolled: number;
  claCreditPoint: number;
  complimentaryActiveCreditPoints: number;
  complimentarySoldCreditPoints: number;
  employeesCheckedIn: number;
  employeesEnrolled: number;
  meetingRoomsBookedToday: number;
  meetingRoomsBookedTodayDuration: number;
  fourWheelParkings: number;
  twoWheelParkings: number;
}

@Component({
  standalone: false,
  selector: 'app-overview-module',
  templateUrl: './overview-module.component.html',
  styleUrls: ['./overview-module.component.scss'],
})
export class OverviewModuleComponent implements OnInit,OnDestroy {
  meetingNav;
  hover: boolean = false;
  isDisplay: any;
  index: any;
  changeText: boolean;
  changeEmployeeText: boolean;
  changeEmployeeCheckedText: boolean;
  changeDayPassText: boolean;
  changeCompliCredit: boolean;
  changeClaCredit: boolean;
  changeMeetingRoomsText: boolean;
  changeParkingText: boolean;
  overviewData = new OverviewData();
  tenantId: any;
  data: any;
  private subscriptions = new Subscription();

  constructor(
    private commonService: CommonService,
    private route: Router,
    private appStateSrv: AppStateProvider,
    private router: Router
  ) {}

  ngOnInit(): void {

    this.getOverviewData();

    // this.meetingNav = [
    //   {
    //     index: '0',
    //     name: 'Overview',
    //     link: '/overview-parkite',
    //   },
    // ];

    // const route = {
    //   index: '0',
    //   name: 'Overview',
    //   link: '/overview-parkite',
    // };
    // this.appStateSrv.setSideNavState(route);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


  getOverviewData() {
    const data = {
      ParkId: 'D825A404-3BCF-4247-A52B-37DB9CF08E65',
    };
    this.subscriptions.add(this.commonService.getOverviewDetail(data).subscribe((res) => {
      console.log(res);
      this.data = res.data;
    }))
  }

  changeImage() {
    this.hover = !this.hover;
  }
  mouseEnter(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  mouseLeave(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  routeToMeetingReport() {
    const fromDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const toDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const queryParams = {
      type: 4,
      fromDate: fromDate,
      toDate: toDate,
      select: 'All',
    };
    console.log('queryParams', queryParams);
    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/parkite-reports']);
  }
}
